// extracted by mini-css-extract-plugin
module.exports = {"ExpressCheckout":"ExpressCheckout_ExpressCheckout__JdgWJ"};